/* 账单只读详情*/
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  DatePicker,
  Button,
  Space,
  message,
} from "antd";
import { HomeOutlined , CheckOutlined, } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import { CustomUpload,CustomUploadNew1 } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const UtilityPaymentModalAdd = ({
  addopen,
  handleModalCancelFn,
  form,
  record,
}) => {
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [filePaths, setFilePaths] = useState([]);
    const customUploadNewRef = useRef(null);
    
    const afterOpenChangeFn = (flag) => {
      if(flag){
        form.setFieldsValue({ ...record })
        getFileListBase64ToUrlFn()
      }else{
        setFilePaths([])
        form.resetFields();
        submitBtnRef?.current?.setLoading(false)
        setBtnDisabled(false);
      }
    }

    const base64ToUrlFn = (base64Data) => {
      // 空值判断
        if (!base64Data) {
        return '';
        }
      const base64HeaderMatch = base64Data.match(/^data:(.*?);base64,/);
      let cleanBase64 = base64Data;
      if (base64HeaderMatch) {
          cleanBase64 = base64Data.replace(base64HeaderMatch[0], '');
      }
      // 将 Base64 转换为二进制数据
      const byteCharacters = atob(cleanBase64);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const url = window.URL.createObjectURL(new Blob([byteArray],{type: base64HeaderMatch?.[1] || 'application/pdf'}))
      return url
    }

    const getFileListBase64ToUrlFn = async() => {
      customUploadNewRef?.current?.initIsLoading(true)
      const {paymentId, foreignId, type} = record
      
      const oldTemp = await http.get(api.getFilePaths, {params:{
        id: paymentId || foreignId,
        type
      }});
      // 空值判断
       if (!oldTemp || !oldTemp.data || oldTemp.data.length === 0) {
      customUploadNewRef?.current?.initUpdateList([]);
      customUploadNewRef?.current?.initIsLoading(false);
      return;
    }

      const response = await http.post(api.getFile, oldTemp?.data || []);
    let list = []
    if(response?.code === '1'){
      list = (oldTemp?.data || [])?.map((item, index) => {
        // 检查 base64 是否存在
        const base64Data = response.data?.[index]?.base64;
        return {
          ...item,
          removeIconFlag: true,
          // 只有 base64 存在时才转换
          allPath: base64Data ? base64ToUrlFn(base64Data) : ''
        }
      })
    }
      customUploadNewRef?.current?.initUpdateList(list);
    }

  const submitBtnRef = useRef();

  return (
    <Modal
          title={
            <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
              <HomeOutlined style={{ marginRight: "8px" }} />
              { record?.color == "#dd4b39" ? 'View Payment History' : 'View PAYMENT' }
              <div
                style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
              ></div>
            </div>
          }
          centered
          open={addopen}
          onCancel={() => handleModalCancelFn()}
          footer={null}
          maskClosable={false}
          destroyOnClose={true}
          afterOpenChange={afterOpenChangeFn}
          width="80%"
        >
          <Form
            form={form}
            layout="horizontal"
            labelCol={{span: 8}}
            wrapperCol={{span: 16}}
            labelWrap={true}
            labelAlign="right"
          >
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  <HomeOutlined style={{ marginRight: "8px" }} />
                  Payment
                </div>
  
                <Form.Item
                  name="prop"
                  label="Prop"
                  rules={[{ required: true }]}
                >
                  <Input.TextArea
                    placeholder="Search street"
                    disabled
                  />
                </Form.Item>
  
                <Form.Item
                  name="vendorName"
                  label="Vendor"
                  rules={[{ required: true }]}
                >
                  <Input
                    disabled
                  />
                </Form.Item>
  
                <Form.Item name="checkMemo" label="Check Memo">
                  <Input
                    disabled
                  />
                </Form.Item>
  
                <Form.Item name="invoiceNumber" label="Invoice">
                  <Input
                    disabled
                  />
                </Form.Item>
  
                <Form.Item name="printBy" label="Usid">
                  <Input
                    disabled
                  />
                </Form.Item>
  
                {commonFn.formInputNumberDoc({
                  name: "amount",
                  label: "Amount",
                  form: form,
                  isNoRequired: true,
                  disabled: true
                })}
    
              </Col>
  
              <Col span={16}>
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  <HomeOutlined style={{ marginRight: "8px" }} />
                  Upload PDF image
                </div>
                <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }} name="uploadFile" label={null}>
                  <CustomUploadNew1
                    ref={(el) => (customUploadNewRef.current = el)}
                    customConfig={{
                      pdfHeight: "50vh",
                      accept: ".jpg, .jpeg, .png, .pdf",
                      status: 'add',
                      suffixKey: 'ext',
                      noUploadBtn: true,
                      noDeleteBtn: true
                    }}
                    setFilePaths={setFilePaths} 
                    filePaths={filePaths} 
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
  );
};

export default UtilityPaymentModalAdd;
